export const LICENSE_UNLIMITED = '2099-12-31'
export const TEXT_UNLIMITED = 'Unlimited'